// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__Owfa5","header":"ClearentDisclaimer_header__7fmT8","inner":"ClearentDisclaimer_inner__2DX2T"};